import { createGlobalStyle } from "styled-components";
import colors from "./colors.js";
import mediaQuery from "./mediaQuery.js";
const GlobalStyle = createGlobalStyle` main {}


* {
	margin: 0;
	padding: 0;
	font-family: 'PPMonumentExtended', sans-serif;
	text-transform:  uppercase;
	font-display: swap;
	font-weight: 900;
	font-size: 1.4rem;
	color: ${colors.dark};
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	font-weight: lighter;
	border: none;
    box-sizing: border-box;
	@media (min-width: 1440px) {
	}
}

div[data-placeholder-image] {
	background-color: transparent !important;
}


html {

	font-size: 62.5%;
	@media (min-width: 1730px) {
		font-size: 0.578vw;
		font-size: clamp(62.5%, .578vw, 75%);
	}
}

body {
	background-color: ${colors.main}
}

p{
	font-size: 1.4rem;
	line-height: 1;
	font-family: 'PPNikkeiPacific', sans-serif;
}

* {
font-size: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6 {}

strong {}

button {
	border: none;
	margin: 0;
	padding: 0;
	width: auto;
	overflow: visible;
	background: transparent;
	color: inherit;
	font: inherit;
	line-height: normal;
	-webkit-font-smoothing: inherit;
	-moz-osx-font-smoothing: inherit;
	-webkit-appearance: none;


}


::selection {
	background-color: ${colors.dark};
	color: ${colors.main};

}

::-moz-selection {
	background-color: ${colors.dark};
	color: ${colors.main};
}

.topHero{

	height: calc(50dvh + 1rem);
	width: 100%;
}

`;

export default GlobalStyle;
